import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from "@angular/router";
import {Injectable} from "@angular/core";
import {AdminService} from "./services/adminLogin.service";

@Injectable()

export class Guard implements CanActivate {

  constructor(private adminService: AdminService, private router: Router) {

  }

  /**
   * Review
   * Todo:
   * Зачем этот файл и эта функцуия вообще?
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.adminService.isLoggined()
  }

}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/Guard.ts